import {
  PostTrainingMaterialInterface,
  DeleteTrainingMaterialInterface,
  UpdateTrainingMaterialInterface,
} from '@/data/payload/contracts/TrainingMaterialRequest'

export class UpdateTrainingMaterialRequest
  implements UpdateTrainingMaterialInterface {
  private title: string
  private fileCode: string
  private recommended: boolean
  private imageThumbnailId: number
  private fileName: string
  private fileByte: string
  private fileUpload: any
  private expireddate: string

  constructor(
    title: string,
    fileCode: string,
    recommended: boolean,
    imageThumbnailId: number,
    fileName: string,
    fileByte: string,
    fileUpload: any,
    expireddate: string
  ) {
    this.title = title
    this.fileCode = fileCode
    this.recommended = recommended
    this.imageThumbnailId = imageThumbnailId
    this.fileName = fileName
    this.fileByte = fileByte
    this.fileUpload = fileUpload
    this.expireddate = expireddate
  }
  public toJSON() {
    if (this.fileByte === '') {
      const data = {
        title: this.title,
        file_code: this.fileCode,
        is_recommended: this.recommended,
        image_thumbnail_id: this.imageThumbnailId,
        expireddate: this.expireddate,
      }
      return JSON.stringify({
        data,
      })
    } else {
      const data = {
        title: this.title,
        file_code: this.fileCode,
        is_recommended: this.recommended,
        image_thumbnail_id: this.imageThumbnailId,
        file_name: this.fileName,
        file_byte: this.fileByte,
        expireddate: this.expireddate,
      }
      return JSON.stringify({
        data,
      })
    }
  }
  public toFormData(): FormData {
    if (this.fileUpload === null) {
      const data = new FormData()
      data.append('title', this.title)
      data.append('fileCode', this.fileCode)
      data.append('isRecommended', this.recommended ? '1' : '0')
      data.append('imageThumbnailId', this.imageThumbnailId.toString())
      data.append('expireddate', this.expireddate)
      return data
    } else {
      const data = new FormData()
      data.append('title', this.title)
      data.append('fileCode', this.fileCode)
      data.append('isRecommended', this.recommended ? '1' : '0')
      data.append('imageThumbnailId', this.imageThumbnailId.toString())
      data.append('fileUpload', this.fileUpload)
      data.append('expireddate', this.expireddate)
      return data
    }
  }
}
export class DeleteTrainingMaterialRequest
  implements DeleteTrainingMaterialInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class TrainingMaterialApiRequest
  implements PostTrainingMaterialInterface {
  private title: string
  private fileCode: string
  private imageThumbnailId: number
  private fileName: string
  private fileByte: string
  private fileUpload: any
  private isRecommended: boolean
  private categoryId: number
  private expireddate: string
  private owner_id: string

  constructor(
    title: string,
    fileCode: string,
    imageThumbnailId: number,
    fileName: string,
    fileByte: string,
    fileUpload: any,
    isRecommended: boolean,
    categoryId: number,
    expireddate: string,
    owner_id: string
  ) {
    this.title = title
    this.fileCode = fileCode
    this.imageThumbnailId = imageThumbnailId
    this.fileName = fileName
    this.fileByte = fileByte
    this.fileUpload = fileUpload
    this.isRecommended = isRecommended
    this.categoryId = categoryId
    this.expireddate = expireddate
    this.owner_id = owner_id
  }

  public toJSON() {
    const data = {
      title: this.title,
      file_code: this.fileCode,
      image_thumbnail_id: this.imageThumbnailId,
      file_name: this.fileName,
      file_byte: this.fileByte,
      is_recommended: this.isRecommended,
      category_id: this.categoryId,
      expireddate: this.expireddate,
      owner_id: this.owner_id,
    }

    return JSON.stringify({
      data,
    })
  }

  public toFormData(): FormData {
    const data = new FormData()
    data.append('title', this.title)
    data.append('fileCode', this.fileCode)
    data.append('imageThumbnailId', this.imageThumbnailId.toString())
    data.append('fileUpload', this.fileUpload)
    data.append('isRecommended', this.isRecommended ? '1' : '0')
    data.append('categoryId', this.categoryId.toString())
    data.append('expireddate', this.expireddate)
    data.append('ownerIds', this.owner_id)
    return data
  }
}
